import {
  Avatar,
  Button,
  Grid2,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase-config/firebase";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUser } from "../context/UserContext";

const paperStyle = {
  padding: "30px",
  margin: "50px auto",
  borderRadius: "15px",
  backgroundColor: "#ffffff",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  width: 350,
};
const avatarStyle = {
  backgroundColor: "#4CAF50",
  marginBottom: "20px",
};
const buttonStyle = {
  marginTop: "20px",
  borderRadius: "30px",
  fontSize: "16px",
};
const linkButtonStyle = {
  marginTop: "10px",
  fontSize: "14px",
  textTransform: "none",
  color: "#4CAF50",
};
const social = {
  margin: "20px 0",
  display: "flex",
  justifyContent: "space-around",
};

const LogIn = () => {
  const { t } = useTranslation("common");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { refreshUserData } = useUser();

  const handleLogIn = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      
      // Refresh user data before navigating to ensure context is updated
      await refreshUserData(user.email || user.phoneNumber);

      navigate("/dashboard", {
        state: { username: user.displayName || email },
      });
    } catch (error) {
    }
  };

  return (
    <Grid2 container justifyContent="center">
      <Paper elevation={6} style={paperStyle}>
        <Grid2 align="center">
          <Avatar style={avatarStyle}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography variant="h5" fontWeight="bold">
            {t("login")}
          </Typography>
        </Grid2>
        <TextField
          label={t("email")}
          type="email"
          variant="outlined"
          placeholder={t("enterEmail")}
          fullWidth
          required
          margin="normal"
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label={t("password")}
          type="password"
          variant="outlined"
          placeholder={t("enterPassword")}
          fullWidth
          required
          margin="normal"
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={buttonStyle}
          fullWidth
          onClick={handleLogIn}
        >
          {t("login")}
        </Button>
        <Button
          style={linkButtonStyle}
          onClick={() => (window.location.href = "/signup")}
        >
          {t("dontHaveAccount")}
        </Button>
        <p align="center">{t("or")}</p>
        <Grid2 style={social}>
          <Button variant="contained" size="small">
            {t("loginWithGoogle")}
          </Button>
          <Button variant="contained" size="small">
            {t("loginWithFacebook")}
          </Button>
        </Grid2>
      </Paper>
    </Grid2>
  );
};

export default LogIn;
